import React, {Component} from 'react';
import AlertErrorOutline from 'material-ui/svg-icons/alert/error-outline';
import {grey300} from 'material-ui/styles/colors';
import CenteredMessage from '../../components/CenteredMessage';

class CenteredErrorMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: !!props.wait,
    };
  }

  componentDidMount() {
    this.waitTimer = setTimeout(
      () => { this.show() },
      this.props.wait,
    );
  }

  componentWillUnmount() {
    clearTimeout(this.waitTimer);
  }

  show = () => {
    this.setState({hidden: false});
  };

  render() {
    return (
      <div>
        {!this.state.hidden &&
          <CenteredMessage>
            <AlertErrorOutline
              style={{
                display: 'inline-block',
                width: 40,
                height: 40,
              }}
              color={grey300}
            />
            <br />
            {this.props.children}
          </CenteredMessage>
        }
      </div>
    );
  }
}

export default CenteredErrorMessage;



// WEBPACK FOOTER //
// ./src/components/CenteredErrorMessage/CenteredErrorMessage.js